import React from 'react';
import './BrandPartnerships.css';

const BrandPartnerships: React.FC = () => {
  return (
    <div className="brand-partnerships">
      <div className="container">
        <div className="page-header">
          <h1>🤝 Brand Partnerships</h1>
          <p>Create meaningful impact through collaboration with Woofly</p>
        </div>

        {/* Hero Section */}
        <section className="partnership-hero">
          <div className="hero-content">
            <h2>Partner With Us</h2>
            <p>
              Join ethical brands in making a real difference for street dogs across India. 
              Our partnerships create lasting impact while building meaningful connections with 
              compassionate communities.
            </p>
            <button className="btn btn-primary">Get Partnership Guide</button>
          </div>
          <div className="hero-image">
            <div className="placeholder-image">
              🤝
              <p>Partnership Image</p>
            </div>
          </div>
        </section>

        {/* Partnership Opportunities */}
        <section className="opportunities-section">
          <h2>Partnership Opportunities</h2>
          <div className="opportunities-grid">
            <div className="opportunity-card">
              <div className="opportunity-icon">🎯</div>
              <h3>Event Sponsorships</h3>
              <p>
                Sponsor our major events, such as adoption fairs, vaccination drives, and feeding drives. Your brand will be featured prominently and make a direct impact for street dogs.
              </p>
              <ul>
                <li>Brand visibility at events</li>
                <li>Social media recognition</li>
                <li>Impact reports</li>
              </ul>
            </div>

            <div className="opportunity-card">
              <div className="opportunity-icon">🛍️</div>
              <h3>Adopt a Dog</h3>
              <p>
                Fund the care of a street dog and become their brand sponsor. In exchange, your brand will receive engaging social media content featuring your support and the dog's journey—showcasing your impact to your audience.
              </p>
              <ul>
                <li>Social media content featuring your brand and the dog</li>
                <li>Recognition as a sponsor</li>
                <li>Updates on the dog's progress</li>
              </ul>
            </div>

            <div className="opportunity-card">
              <div className="opportunity-icon">📱</div>
              <h3>Content Collaboration</h3>
              <p>
                Create engaging content together that educates and inspires action 
                for dog welfare.
              </p>
              <ul>
                <li>Co-created campaigns</li>
                <li>Cross-platform promotion</li>
                <li>Storytelling opportunities for both parties</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Success Stories */}
        <section className="success-stories">
          <h2>Success Stories</h2>
          <div className="stories-grid">
            <div className="story-card">
              <div className="story-image">
                <div className="placeholder-image">🏥</div>
              </div>
              <div className="story-content">
                <h3>PetCare Plus: Vaccination Drives</h3>
                <p>
                  PetCare Plus sponsored 5 vaccination drives across Mumbai, helping over 200 dogs become rabies-free. Their support brought the community together and showcased their commitment to animal welfare.
                </p>
                <div className="story-stats">
                  <span>200+ dogs vaccinated</span>
                  <span>5 drives completed</span>
                </div>
              </div>
            </div>

            <div className="story-card">
              <div className="story-image">
                <div className="placeholder-image">🍽️</div>
              </div>
              <div className="story-content">
                <h3>FreshFood Co.: Feeding Program</h3>
                <p>
                  FreshFood Co. funded a daily feeding program, providing nutritious meals to street dogs. Their employees volunteered, and the campaign generated a surge of positive engagement on social media.
                </p>
                <div className="story-stats">
                  <span>Daily feeding program</span>
                  <span>50+ employee volunteers</span>
                </div>
              </div>
            </div>

            <div className="story-card">
              <div className="story-image">
                <div className="placeholder-image">🐶</div>
              </div>
              <div className="story-content">
                <h3>Coco’s Journey: Brand Rescue</h3>
                <p>
                  Coco, a street dog with distemper and a fractured jaw, was sponsored by a compassionate brand. Their funding enabled life-saving treatment and inspiring recovery updates that resonated with their audience.
                </p>
                <div className="story-stats">
                  <span>Survived distemper</span>
                  <span>Jaw fracture healed</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Partnership Process */}
        <section className="process-section">
          <h2>How to Partner</h2>
          <div className="process-steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Connect</h3>
              <p>Reach out to discuss partnership opportunities and alignment</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Plan</h3>
              <p>We'll work together to create a customized partnership plan</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Execute</h3>
              <p>Launch your partnership with full support from our team</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h3>Impact</h3>
              <p>Track and celebrate the real impact you're making</p>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-section">
          <div className="contact-content">
            <h2>Ready to Partner?</h2>
            <p>Let's discuss how we can create meaningful impact together.</p>
            <div className="contact-buttons">
              <button className="btn btn-primary">Schedule a Call</button>
              <button className="btn btn-secondary">Download Partnership Guide</button>
            </div>
            <div className="contact-info">
              <p>📧 partnerships@woofly.org</p>
              <p>📱 +91 98765 43210</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default BrandPartnerships; 